import React from 'react'
import Navigation from "./Navigation"

const PageNotFound = (props) => {
    return (
        <div>
            <h1>Page Not found !!!</h1>
            <h4>Available pages</h4>
            <Navigation/>
        </div>
    )
}

export default PageNotFound
